import { render } from "./AddSupplierLocation.vue?vue&type=template&id=33bc54ca&scoped=true"
import script from "./AddSupplierLocation.vue?vue&type=script&lang=js"
export * from "./AddSupplierLocation.vue?vue&type=script&lang=js"

import "./AddSupplierLocation.vue?vue&type=style&index=0&id=33bc54ca&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33bc54ca"]])

export default __exports__